import axios from 'axios'
import prefixedUrl from '../helpers/prefixedUrl'

export default function (config = {}) {
  const client = axios.create(config)

  client.interceptors.request.use(config => {
    let url = config.url
    if (!url.startsWith('http')) {
      url = prefixedUrl(url)
    }
    return {
      ...config,
      url
    }
  })
  client.interceptors.response.use(
    res => res,
    err => (err.response ? throw err.response.data : throw new Error('Error')) // TODO: add custom error message
  )

  return client
}
